import type { ReactElement } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import i18next from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { routerOptions } from 'config/router'
import AlertProvider from 'context/AlertContext'
import AppProvider from 'context/AppContext/AppContext'
import AuthProvider from 'context/AuthContext/AuthContext'
import withAbilities from 'HOC/withAbilities'
import { HelmetProvider, Helmet } from 'react-helmet-async'

import './app.css'

const queryClient = new QueryClient()
const router = createBrowserRouter(routerOptions)
const helmetContext = {}

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18next
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: 'en',
    fallbackLng: ['pl', 'en'],
  })
const App = (): ReactElement => (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <QueryClientProvider client={queryClient}>
      <AlertProvider>
        <HelmetProvider context={helmetContext}>
          <AuthProvider>
            <AppProvider>
              <Helmet defaultTitle={process.env.REACT_APP_BRAND}>
                {!(process.env.REACT_APP_ENVIRONMENT === 'production') ? (
                  <meta name="robots" content="noindex, nofollow" />
                ) : null}
              </Helmet>
              <RouterProvider router={router} />
              <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
            </AppProvider>
          </AuthProvider>
        </HelmetProvider>
      </AlertProvider>
    </QueryClientProvider>
  </LocalizationProvider>
)

export default withAbilities(App)
